var map = {
	"./events-cat.webp": 2086,
	"./games-cat.webp": 2087,
	"./live-casino-cat.webp": 2088,
	"./lottery-cat.webp": 2089,
	"./other-cat.webp": 2090,
	"./p2p-cat.webp": 2091,
	"./pd-table.webp": 2092,
	"./privacy-policy-title-bm.webp": 2093,
	"./privacy-policy-title-cn.webp": 2094,
	"./privacy-policy-title-id.webp": 2095,
	"./privacy-policy-title.webp": 2096,
	"./promos-1.webp": 2097,
	"./promos-2.webp": 2098,
	"./promos-3.webp": 2099,
	"./promos-4.webp": 2100,
	"./question.webp": 2101,
	"./sideBar-bg.webp": 2102,
	"./slot-cat.webp": 2103,
	"./special-cat.webp": 2104,
	"./sports-cat.webp": 2105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 478;